export const orders = (state) => state.cart

export const getOrderByIndex = (state) => _index => {
    return state.cart[_index]
}
